import {Badge} from "@mantine/core"
import {
    Application,
    ApplicationCategory
} from "../types.ts";


const CATEGORY_CONFIG = {
    [ApplicationCategory.ADMIN]: {
        color: 'red',
        label: 'Admin'
    },
    [ApplicationCategory.BUSINESS]: {
        color: 'blue',
        label: 'Business'
    },
    [ApplicationCategory.CONSUMER]: {
        color: 'orange',
        label: 'Consumer'
    }
} as const;

export const ApplicationCategoryBadge = ({record}: { record: Application }) => {

    if (!record?.applicationCategory) {
        return <Badge color='dark'>Invalid Category</Badge>;
    }

    const config = CATEGORY_CONFIG[record.applicationCategory as ApplicationCategory];
    return <Badge color={config.color}>{config.label}</Badge>;

}